import React from "react";

import FormattedAmount from "pages/_components/FormattedAmount";

import Image from "pages/_components/Image";
import InfoTag from "pages/echeck/components/InfoTag";
import { statusTagColor } from "util/echecks";
import { bool, number, string } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import CustomData from "../../_components/CustomData/CustomData";

function getAmountTagClass(status) {
    if (status === transactionStatus.FINISHED) {
        return "amount tag tag-success";
    }
    if (status === transactionStatus.FAILED) {
        return "amount tag tag-error";
    }
    return "amount tag tag-warning";
}

const EcheqHeaderTicket = ({ estado, caracter, moneda, monto, id, status, isDesktop }) => (
    <div className={`grid-table-data echeq-header-ticket ${isDesktop ? "desktop" : "mobile"}`}>
        <div className="echeq-logo">
            <Image src="images/logoCompany.svg" />
        </div>

        <div className={`echeq-amount ${isDesktop ? "desktop" : "mobile"}`}>
            <CustomData
                dataClass={getAmountTagClass(status)}
                titleText="echecks.amount"
                titleTextType="I18N"
                valueText={<FormattedAmount currency={moneda} quantity={monto} />}
            />
        </div>
        <div className={`echeq-info ${isDesktop ? "desktop" : "mobile"}`}>
            <span>Echeq {id}</span>
            {caracter && <InfoTag type="info" message={caracter} tagBackground={statusTagColor(estado)} />}
        </div>
    </div>
);

EcheqHeaderTicket.propTypes = {
    estado: string.isRequired,
    caracter: string.isRequired,
    moneda: string.isRequired,
    monto: number.isRequired,
    id: string.isRequired,
    status: string,
    isDesktop: bool.isRequired,
};

EcheqHeaderTicket.defaultProps = {
    status: "",
};

export default EcheqHeaderTicket;
